import React from "react";

import { useTranslation } from "utils";

import { AlertBanner } from "components";

export const AutofillBanner = () => {
  const { t } = useTranslation("footprinting");
  return <AlertBanner className="prefill-reminder-banner" type="recommended" iconName="tabler/bulb" iconAlign="start" description={t("prefillReminder")} />;
};
